import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { RouteProps } from 'react-router';
// import { APP_LOCALES } from '../../i18n';
import Bubble, { BubbleType } from '../../components/bubble/bubble';
import Button, { ButtonType } from '../../components/button/button';
import Container from '../../components/layout/container';
import { ROUTE_TESTERS, ROUTE_SPORTS_UNIVERSE } from '../../RouteList';
import messages from './messages';
import classNames from 'classnames';
import Image, { ImageType } from '../../components/image/image';
class About extends React.Component<RouteProps & any, any> {
  constructor(props) {
    super(props);
    props.routing.history.subscribe((location, action) => {
      if (action === 'POP') {
        this.props.dataStore.setCurrentRouteIsValid(
          this.props.dataStore.emailOptinValidator()
        );
      }
    });
  }

  public render() {
    const {
      routing: { push },
      dataStore: { isPrivate, locale },
      intl
    } = this.props;

    return (
      <Container>
        <Bubble type={BubbleType.Wide}>
          <Button
            type={ButtonType.circleClose}
            onClick={() =>
              push(isPrivate ? ROUTE_TESTERS : ROUTE_SPORTS_UNIVERSE)
            }
          />
          <div className={classNames('c-bubble__content c-bubble--centered')}>
            <p className={classNames('c-bubble__paragraph')}>
              <FormattedMessage {...messages.aboutDescription} />
              <br />
              <FormattedMessage {...messages.aboutCopyright} />
            </p>

            <p className={classNames('c-bubble__paragraph')}>
              <FormattedHTMLMessage {...messages.aboutMore} />
            </p>

            <div className={classNames('c-bubble__sponsors')}>
              {locale.startsWith('nl') ? (
                <Image
                  type={ImageType.logoUgentNL}
                  imgSrc="/images/png/sponsors/UGent_NL.png"
                  alt="UGent"
                  imgUrl="https://ugent.be"
                />
              ) : (
                <Image
                  type={ImageType.logoUgentEN}
                  imgSrc="/images/png/sponsors/UGent_EN.png"
                  alt="UGent"
                  imgUrl="https://ugent.be/en"
                />
              )}
            </div>

            <div className="u-margin-top-large u-1-of-1">
              <Button
                type={ButtonType.primary}
                label={intl.formatMessage(messages.aboutButton)}
                onClick={() => {
                  push(isPrivate ? ROUTE_TESTERS : `/`);
                }}
              />
            </div>
          </div>
        </Bubble>
      </Container>
    );
  }
}

export default inject('dataStore', 'routing')(injectIntl(observer(About)));



// WEBPACK FOOTER //
// ./src/containers/about/About.tsx